import { FeedTemplate } from "components/templates/FeedTemplate/FeedTemplate";

export const FeedPage = () => {
    return <FeedTemplate />;
}